import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { trackAddToCart } from '../utils/pixel';
export function PricingSection() {
  return <section id="precio" className="w-full px-6 py-10 md:py-14" data-id="element-245">
      <div className="max-w-2xl mx-auto" data-id="element-246">
        <AnimatedSection data-id="element-247">
          <div className="w-12 h-px bg-sand mx-auto mb-8" data-id="element-248" />
        </AnimatedSection>

        <AnimatedSection data-id="element-249">
          <div className="text-center" data-id="element-250">
            <div className="bg-white/70 rounded-3xl border border-cream-dark p-6 md:p-10" data-id="element-251">
              <p className="text-warm-gray text-sm tracking-widest uppercase mb-4 font-medium" data-id="element-252">
                Acceso inmediato
              </p>

              <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-3" data-id="element-253">
                RESET 48
              </h2>
              <p className="text-warm-gray text-base mb-5" data-id="element-254">
                Casa Caminable en 2 Días (sin motivación)
              </p>

              <div className="inline-block bg-teal/10 text-teal font-semibold text-sm px-4 py-1.5 rounded-full mb-5 tracking-wide" data-id="element-255">
                68% OFF
              </div>

              <div className="flex items-baseline justify-center gap-3 mb-1" data-id="element-256">
                <span className="text-warm-gray text-2xl line-through decoration-warm-gray/40" data-id="element-257">
                  $19.99
                </span>
                <span className="font-serif text-6xl md:text-7xl text-teal" data-id="element-258">
                  $6.36
                </span>
                <span className="text-warm-gray text-lg" data-id="element-259">USD</span>
              </div>

              <p className="text-warm-gray text-sm mb-8 max-w-sm mx-auto leading-relaxed" data-id="element-260">
                Porque cuando estás así, necesitas una solución rápida y
                accesible.
                <br data-id="element-261" />
                No otro curso de 8 semanas que no vas a terminar.
              </p>

              <a href="https://tucasareset.com/cart/52058806419778:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="inline-block bg-teal text-white font-semibold text-lg px-10 py-4 rounded-full transition-transform duration-200 hover:scale-105 hover:bg-teal-dark focus:outline-none focus:ring-2 focus:ring-teal focus:ring-offset-2 focus:ring-offset-cream" role="button" data-id="element-262">
                Consigue RESET 48 ahora
              </a>

              <p className="text-warm-gray/60 text-xs mt-6" data-id="element-263">
                Descarga inmediata · PDF · Sin suscripción
              </p>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}